import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    flex: {
      display: 'flex',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontSize: '0.875rem',
      marginRight: theme.spacing(),
    },
    status: {
      textTransform: 'uppercase',
      fontSize: '0.625rem',
      fontWeight: 500,
      borderRadius: '16px',
      padding: theme.spacing(0, 1),
    },
    statusNew: {
      backgroundColor: '#9E9E9E',
      color: theme.palette.common.white,
    },
    statusInProgress: {
      backgroundColor: '#FDD835',
      color: theme.palette.common.black,
    },
    statusCompleted: {
      backgroundColor: '#43A047',
      color: theme.palette.common.white,
    },
    dueDateSoon: {
      color: theme.palette.warning.main,
    },
    dueDatePast: {
      color: theme.palette.error.main,
    },
  };
};
